import dayjs from 'dayjs';

export const isDateToday = (date) => dayjs(date).diff(new Date(), 'days', true) <= 0;

export const filterTimesAfterNow = (list) => list.filter((t) => {
  const now = dayjs().format('HH:mm:ss');
  const endTime = dayjs(t.end, 'HH:mm:ss');
  return dayjs(now, 'HH:mm:ss').isBefore(endTime) || dayjs(now, 'HH:mm:ss').isSame(endTime);
});

export function isSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth();
}
export function addDurationToTime(time, duration) {
  const [hours, minutes] = duration.split(':');
  const durationHours = parseInt(hours, 10);
  const durationMinutes = parseInt(minutes, 10);

  return dayjs(time).add(durationHours, 'hours').add(durationMinutes, 'minutes');
}
